import { Outlet } from "react-router-dom"

import { AppErrorBoundary } from "@/app/app-error-boundary"
import { AppProviders } from "@/app/runtime-providers"

export function RootProvidersRoute() {
  return (
    <AppProviders>
      <AppErrorBoundary>
        <div className='flex min-h-0 w-full flex-1 flex-col'>
          <Outlet />
        </div>
      </AppErrorBoundary>
    </AppProviders>
  )
}
